import React from 'react';

import Icon from './Icon/Icon';

const CardProcessor = ({ children, style = {} }) => {
  switch (children) {
    case 'MASTERCARD':
    case 'MC':
      return <Icon icon="cards-visuals-mastercard" size={44} />;
    case 'VISA':
      return <Icon icon="cards-visuals-visa" size={44} />;
    case 'DISCOVER':
      return <Icon icon="cards-visuals-discover" size={44} />;
    case 'AMEX':
      return <Icon icon="cards-visuals-amex" size={44} />;
    case 'Debit MasterCard':
      return <Icon icon="cards-visuals-mastercard" size={44} />;
    case 'Diners':
      return <Icon icon="cards-visuals-diners" size={44} />;
    case 'Discover':
      return <Icon icon="cards-visuals-discover" size={44} />;
    case 'JCB':
      return <Icon icon="cards-visuals-jcb" size={44} />;
    case 'Maestro':
      return <Icon icon="cards-visuals-maestro" size={44} />;
    case 'MasterCard':
      return <Icon icon="cards-visuals-mastercard" size={44} />;
    case 'Visa Credit':
      return <Icon icon="cards-visuals-visa" size={44} />;
    case 'Visa Debit':
      return <Icon icon="cards-visuals-visa" size={44} />;
    case 'Visa Electron':
      return <Icon icon="cards-visuals-visa" size={44} />;
    case 'ACH':
      return (
        <div className="flex w-11 items-center justify-center rounded-md border border-solid border-neutral-200 p-1">
          <Icon icon="building-mono" size={20} />
        </div>
      );
    default:
      return <div style={style}>{children}</div>;
  }
};

export default CardProcessor;
